import type { ReactNode } from "react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

type StatusVariant = "positive" | "warning" | "neutral";

const badgeVariant: Record<StatusVariant, "default" | "destructive" | "secondary"> = {
  positive: "default",
  warning: "destructive",
  neutral: "secondary",
};

export function StatusBadge({
  variant = "neutral",
  className,
  children,
}: {
  variant?: StatusVariant;
  className?: string;
  children: ReactNode;
}) {
  return (
    <Badge variant={badgeVariant[variant]} className={cn("gap-1.5", className)}>
      <span className="size-1.5 rounded-full bg-current" />
      {children}
    </Badge>
  );
}
